import {gql, useQuery} from "@apollo/client";
import {Carrier_FIELDS, CarrierType} from "../../../../../graphql/types/CarrierType";
import {useEffect, useState} from "react";

export const GET_ALL_CARRIERS = gql`
  query GetAllCarriers {
    allCarriers: getAllTmsCarriers {
      ...CarrierFields
    }
  }
  ${Carrier_FIELDS}
`;

interface GetAllCarriersResponse {
  allCarriers: CarrierType[];
}

export const useAllCarriers = () => {
  const [allCarriers, setAllCarriers] = useState<CarrierType[]>([]);
  const {data, loading, error, refetch} = useQuery<GetAllCarriersResponse>(GET_ALL_CARRIERS);

  useEffect(() => {
    if (data) {
      setAllCarriers(data.allCarriers);
    }
  }, [data]);

  return { allCarriers, loading, error, refetch };
};


